import { createEvent, createStore } from 'effector'
import { persist } from 'effector-storage/local'
import { LocalStorageKey } from '~/shared/constants'

export const init = createEvent()

export const setLandingRegion = createEvent<string>()

export const $landingRegion = createStore<string | null>(null).on(
  setLandingRegion,
  (_, landingRegion) => {
    return landingRegion?.toLowerCase() ?? ''
  }
)

export const setLandingNotificationPopupOpened = createEvent<boolean>()
export const $isLandingNotificationPopupOpened = createStore<boolean>(false).on(
  setLandingNotificationPopupOpened,
  (_, isOpened) => isOpened
)

export const setWasSkippedLandingNotificationPopup = createEvent<{
  isLandingNotificationSkipped: boolean
  region: string
}>()

export const $wasSkippedLandingNotificationPopupStorage = createStore<{
  isLandingNotificationSkipped: boolean
  region: string
}>({
  isLandingNotificationSkipped: false,
  region: '',
}).on(
  setWasSkippedLandingNotificationPopup,
  (_, { isLandingNotificationSkipped, region }) => {
    return { isLandingNotificationSkipped, region }
  }
)

persist({
  store: $wasSkippedLandingNotificationPopupStorage,
  key: LocalStorageKey.WasSkippedLandingNotificationPopup,
})

export const $wasSkippedLandingNotificationPopup =
  $wasSkippedLandingNotificationPopupStorage.map((storage) => ({
    isLandingNotificationSkipped:
      storage?.isLandingNotificationSkipped ?? false,
    region: storage?.region ?? '',
  }))

export const setLandingNotificationHeight = createEvent<number>()
export const $landingNotificationHeight = createStore<number>(0).on(
  setLandingNotificationHeight,
  (_, height) => height
)

// Tracks when landing region differs from the user's primary (preferred) region.
// Used to show the landing notification popup and to reload home rows on leave.
export const setRegionMismatch = createEvent<boolean>()
export const resetRegionMismatch = createEvent<void>()
export const $isRegionMismatch = createStore(false)
  .reset(resetRegionMismatch)
  .on(setRegionMismatch, (_, isRegionMismatch) => isRegionMismatch)
